import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import PruTable from '../../../../../../common/components/PruTable/PruTable';
import { useHistory } from 'react-router-dom';
import { getDefaultDisplayDate } from '../../../../../../common/utils/time-utils';
import { NOTE_PATH, SIMULATION_TOOL_PATH } from 'src/app/modules/SimulationTool/constants';
import { NotePaginateList } from 'src/app/modules/SimulationTool/types/note-setting';

type NoteSettingListProps = {
  isLoading: boolean;
  noteList?: NotePaginateList;
  onRefresh: () => void;
  onChangePage: (page: number, rowsPerPage: number) => void;
  onSort: (sortingState: { key: string; value?: string }) => void;
};

const NoteSettingList: FC<NoteSettingListProps> = ({
  isLoading,
  onRefresh,
  onChangePage,
  noteList,
  onSort,
}) => {
  const history = useHistory();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  return (
    <PruTable
      disableBulkSelect
      dataSource={noteList?.items}
      isLoading={isLoading}
      onRefresh={onRefresh}
      title={Translation('noteSetting.list')}
      operationDef={[
        {
          title: Translation('section.common.operation.edit'),
          tooltipText: 'Edit Note',
          onClick: (row) => history.push(`${SIMULATION_TOOL_PATH}${NOTE_PATH}/edit/${row._id}`),
        },
      ]}
      columnDef={[
        {
          isId: true,
          hidden: true,
          keyIndex: '_id',
          displayName: '',
          renderData: () => '',
        },
        {
          keyIndex: 'formName',
          displayName: Translation('noteSetting.formName'),
          renderData: (row) => row.formName,
        },
        {
          keyIndex: 'updatedBy',
          displayName: Translation('noteSetting.lastUpdatedBy'),
          renderData: (row) => row.updatedBy,
        },
        {
          keyIndex: 'updatedAt',
          align: 'center',
          displayName: Translation('noteSetting.lastUpdatedAt'),
          renderData: (row) => getDefaultDisplayDate(row.updatedAt),
          sortable: true,
          onSort: (sort) => {
            onSort({
              key: 'lastUpdateDateSort',
              value: sort['updatedAt'],
            });
          },
        },
      ]}
      totalPages={noteList?.totalPages}
      totalRecords={noteList?.totalRecords}
      onChangePage={onChangePage}
    />
  );
};

export default NoteSettingList;
